(function () {
  function animateOpen(details) {
    const content = details.querySelector(".az-acc-content");
    if (!content) return;

    // from 0 -> content height
    content.style.height = "0px";
    const target = content.scrollHeight;

    requestAnimationFrame(() => {
      content.style.height = target + "px";
    });

    const onEnd = () => {
      // allow content to grow naturally after animation
      content.style.height = "auto";
      content.removeEventListener("transitionend", onEnd);
    };
    content.addEventListener("transitionend", onEnd);
  }

  function animateClose(details) {
    const content = details.querySelector(".az-acc-content");
    if (!content) return;

    // from current height -> 0
    const current = content.scrollHeight;
    content.style.height = current + "px";

    requestAnimationFrame(() => {
      content.style.height = "0px";
    });
  }

  function closeOthers(current, scope) {
    scope.querySelectorAll("details.az-acc[open]").forEach((d) => {
      if (d !== current) {
        animateClose(d);
        d.removeAttribute("open");
      }
    });
  }

  function initFooterAccordion() {
    const footer = document.querySelector("footer.footer");
    if (!footer) return;

    footer.classList.add("az-footer-accordion");

    const blocks = footer.querySelectorAll(".footer-block");
    if (!blocks.length) return;

    blocks.forEach((block) => {
      if (block.querySelector("details.az-acc")) return;

      const heading =
        block.querySelector(".footer-block__heading") ||
        block.querySelector("h2") ||
        block.querySelector("h3");
      if (!heading) return;

      // Only convert blocks that contain a menu/list of links
      const contentContainer =
        block.querySelector(".footer-block__details-content") ||
        block.querySelector(".footer-block__content") ||
        block.querySelector(".footer-block__details") ||
        block.querySelector("ul");
      if (!contentContainer || block.querySelectorAll("a").length === 0) return;

      const details = document.createElement("details");
      details.className = "az-acc";

      const summary = document.createElement("summary");

      const title = document.createElement("span");
      title.className = "az-acc-title";
      title.textContent = heading.textContent.trim();

      const iconWrap = document.createElement("span");
      iconWrap.className = "az-acc-icon";
      iconWrap.innerHTML = `
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M5 8l5 5 5-5"></path>
        </svg>
      `;

      summary.appendChild(title);
      summary.appendChild(iconWrap);

      const wrap = document.createElement("div");
      wrap.className = "az-acc-content";
      wrap.appendChild(contentContainer);

      heading.remove();

      details.appendChild(summary);
      details.appendChild(wrap);
      block.prepend(details);

      // Start closed (animated)
      wrap.style.height = "0px";

      summary.addEventListener("click", (e) => {
        e.preventDefault();

        if (!details.open) {
          details.setAttribute("open", "");
          animateOpen(details);
          closeOthers(details, footer);
        } else {
          animateClose(details);
          details.removeAttribute("open");
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initFooterAccordion);
  document.addEventListener("shopify:section:load", initFooterAccordion);
})();